import { StoreState } from '../store-interfaces';

export const getEmailTemplates = (state: StoreState) =>
  state.emailTemplates.entities;

export const getEmailTemplatesPagination = (state: StoreState) =>
  state.emailTemplates.pagination;

export const getEmailTemplatesLoading = (state: StoreState) =>
  state.emailTemplates.busy;
